import React, { Component } from 'react';
import {
    Button, FormControl, InputGroup, PageHeader,
    Modal, Label, Glyphicon, ControlLabel
} from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn, DeleteButton } from 'react-bootstrap-table';
import { Link } from "react-router-dom";
import 'react-phone-input-2/lib/style.css';

import ColumnFormatter from '../../common/ColumnFormatter';
import { PersonalInformationComponent, AddressComponent } from '../../common/FunctionComponents';

import './../../common/Common.css';

export class ApplicantDetails extends Component {
    displayName = 'Applicant Details';

    constructor(props) {
        super(props);

        this.state = {
            applicantId: this.props.match.params.applicantId,
            familyMembers: [],
            addressHistory: [],
            errorMessages: [],

            streetNumberName: '',
            unitType: '',
            unitNumber: '',
            city: '',
            state: '',
            zipCode: '',
            country: '',
            postalCode: '',
            province: '',
            fromDate: '',
            toDate: '',

            dateOfBirth: '1990-01-01',

            showAddressHistoryModal: false,
            showFamilyMemberModal: false
        }

        this.handleToggleVisibilityFamilyMemberModal = this.handleToggleVisibilityFamilyMemberModal.bind(this);
        this.handleFamilyMemberSubmit = this.handleFamilyMemberSubmit.bind(this);

        this.handleToggleVisibilityAddressHistoryModal = this.handleToggleVisibilityAddressHistoryModal.bind(this);
        this.handleAddressHistorySubmit = this.handleAddressHistorySubmit.bind(this);
        this.closeAddressHistoryModal = this.closeAddressHistoryModal.bind(this);


        this.handleInputChange = this.handleInputChange.bind(this);


        this.getFamilyMemberData();
        this.getAddressHistoryData();
    }

    getFamilyMemberData() {

        const requestOptions = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${this.props.auth.getAccessToken()}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }

        let url = `api/familyMemberService/${localStorage.getItem('agency_key')}/${this.state.applicantId}`;

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(data => this.setState({
                familyMembers: data
            }));
    }

    getAddressHistoryData() {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${this.props.auth.getAccessToken()}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }

        let url = `api/pollservice/${localStorage.getItem('agency_key')}/address/${this.state.applicantId}`;

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(data => {
                this.setState({
                    addressHistory: data.result
                });
            });
    }

    componentDidMount() {
        this.getFamilyMemberData();
    }


    handleIsPetitionerChange(evt) {
        this.setState({ isPetitioner: !this.state.isPetitioner });
    }

    handleInputChange(evt) {
        const value = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
        this.setState({ [evt.target.name]: value });
    }

    handleToggleVisibilityFamilyMemberModal() {
        this.setState({ showFamilyMemberModal: !this.state.showFamilyMemberModal });
    }

    handleToggleVisibilityAddressHistoryModal() {
        this.setState({ showAddressHistoryModal: !this.state.showAddressHistoryModal });
    }

    closeAddressHistoryModal() {
        this.handleToggleVisibilityAddressHistoryModal();
        this.clearAddressHistory();
    }

    handleFamilyMemberSubmit(event) {
        event.preventDefault();

        //post familyMember
        this.postFamilyMember();

        //clear state fields
        this.handleToggleVisibilityFamilyMemberModal();
    }

    handleAddressHistorySubmit(event) {
        event.preventDefault();
        this.postAddressHistory();
        this.handleToggleVisibilityAddressHistoryModal();
    }

    postFamilyMember() {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${this.props.auth.getAccessToken()}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                applicantId: this.state.applicantId,
                gender: this.state.gender,
                firstName: this.state.firstName,
                middleName: this.state.middleName,
                lastName: this.state.lastName,
                dateOfBirth: this.state.dateOfBirth,
                nationality: this.state.nationality,
                relation: this.state.relation,
                isPetitioner: this.state.isPetitioner
            })
        }

        let url = `api/familyMemberService/${localStorage.getItem('agency_key')}/`;

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(data => {
                var messages = [];

                data.errorMessages.map(x => messages.push(x.errorMessage));

                this.setState({
                    errorMessages: messages
                });

                if (messages.length === 0) {
                    this.getFamilyMemberData();
                    this.setState({
                        gender: '',
                        firstName: '',
                        middleName: '',
                        lastName: '',
                        dateOfBirth: '1990-01-01',
                        nationality: '',
                        relation: ''
                    });
                }
            });

    }

    postAddressHistory() {

        let fromDate = this.state.fromDate !== '' ? this.state.fromDate : null;
        let toDate = this.state.toDate !== '' ? this.state.toDate : null;

        const requestOptions = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${this.props.auth.getAccessToken()}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: this.state.addressId,
                streetNumberName: this.state.streetNumberName,
                unitType: this.state.unitType,
                unitNumber: this.state.unitNumber,
                city: this.state.city,
                state: this.state.state,
                zipCode: this.state.zipCode,
                country: this.state.country,
                postalCode: this.state.postalCode,
                province: this.state.province,
                fromDate: fromDate,
                toDate: toDate,
                linkTo: 'History'
            })
        }

        let url = `api/pollservice/${localStorage.getItem('agency_key')}/address/${this.state.applicantId}`;
        fetch(url, requestOptions)
            .then(response => response.json())
            .then(data => {
                var messages = [];

                if (data.errorMessage != null)
                    data.errorMessages.map(x => messages.push(x.errorMessage));

                this.setState({
                    errorMessages: messages
                });

                if (messages.length === 0) {
                    this.getAddressHistoryData();
                    this.clearAddressHistory();
                }
            });
    }

    handleDeleteButtonClick = () => {

        const requestOptions = {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${this.props.auth.getAccessToken()}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }

        var familyMemberId = this.refs.familyMembersTable.state.selectedRowKeys[0];

        if (familyMemberId === undefined) {
            return;
        }

        let url = `api/familyMemberService/${localStorage.getItem('agency_key')}/${this.state.applicantId}/${familyMemberId}`;

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(data => {
                this.getFamilyMemberData();
            });
    }

    handleDeleteAddressHistoryButtonClick = () => {

        const requestOptions = {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${this.props.auth.getAccessToken()}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }

        var addressId = this.refs.addressHistoryTable.state.selectedRowKeys[0];

        if (addressId === undefined) {
            return;
        }

        let url = `api/pollservice/${localStorage.getItem('agency_key')}/address/${this.state.applicantId}/${addressId}`;

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(data => {
                this.getAddressHistoryData();
            });
    }

    createCustomDeleteButton = (onClick) => {
        return (
            <DeleteButton
                btnText='Delete Member'
                btnContextual='btn-warning'
                btnGlyphicon='glyphicon-trash' />
        );
    }


    onAddressHistoryRowDoubleClick = row => {

        if (row.fromDate !== '' && row.fromDate != null)
            this.setState({ fromDate: new Date(row.fromDate).toISOString().split('T')[0] });
        else
            this.setState({ fromDate: null });

        if (row.toDate !== '' && row.toDate != null)
            this.setState({ toDate: new Date(row.toDate).toISOString().split('T')[0] });
        else
            this.setState({ toDate: null });

        this.setState({
            addressId: row.id,
            streetNumberName: row.streetNumberName,
            unitType: row.unitType,
            unitNumber: row.unitNumber,
            city: row.city,
            state: row.state,
            zipCode: row.zipCode,
            country: row.country,
            postalCode: row.postalCode,
            province: row.province,
            showAddressHistoryModal: true
        });
    }

    clearAddressHistory() {
        this.setState({
            addressId: 0,
            streetNumberName: '',
            unitType: '',
            unitNumber: '',
            city: '',
            state: '',
            zipCode: '',
            country: '',
            postalCode: '',
            province: '',
            fromDate: '',
            toDate: ''
        });
    }

    render() {

        const selectRowProp = {
            mode: 'radio'
        };

        const options = {
            deleteBtn: this.createCustomDeleteButton,
            afterDeleteRow: this.handleDeleteButtonClick
        };

        const addressHistoryOptions = {
            onRowDoubleClick: this.onAddressHistoryRowDoubleClick,
            afterDeleteRow: this.handleDeleteAddressHistoryButtonClick,
            deleteBtn: onclick => {
                return (
                    <DeleteButton
                        btnText='Delete Address'
                        btnContextual='btn-warning'
                        btnGlyphicon='glyphicon-trash' />
                );
            }
        };

        return (
            <div>
                <PageHeader>
                    <div>
                        <small>
                            <Button>
                                <Link to={`/applicant/${this.state.applicantId}`}>
                                    <Glyphicon glyph='arrow-left' /> Back to <br /> Applicant
                                </Link>
                            </Button>
                        </small>

                    </div>
                    Applicant Details
                    <small> Family Members and Address History

                    </small>
                </PageHeader>

                <Modal show={this.state.showFamilyMemberModal}
                    onHide={this.handleToggleVisibilityFamilyMemberModal}>
                    <Modal.Header>
                        <Modal.Title>Add Family Member</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={this.handleFamilyMemberSubmit}>
                            <PersonalInformationComponent
                                firstName={this.state.firstName}
                                middleName={this.state.middleName}
                                lastName={this.state.lastName}
                                gender={this.state.gender}
                                dateOfBirth={this.state.dateOfBirth}
                                nationality={this.state.nationality}
                                handleInputChange={this.handleInputChange}
                            />

                            <ControlLabel>Relation</ControlLabel>
                            <FormControl name="relation" componentClass="select" placeholder="Relation"
                                value={this.state.relation} onChange={this.handleInputChange}>
                                <option></option>
                                <option value="Spouse">Spouse</option>
                                <option value="Parent">Parent</option>
                                <option value="Sibling">Sibling</option>
                                <option value="Child">Child</option>
                            </FormControl>

                            <div>
                                <ControlLabel>Check if family member is the petitioner:</ControlLabel>
                                <input type="checkbox" name="isPetitioner"
                                    checked={this.state.isPetitioner}
                                    onChange={this.handleInputChange} />
                            </div>

                            <div style={{ paddingTop: '1%' }} >
                                <Button type="submit"> Submit </Button>
                            </div>
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.handleToggleVisibilityFamilyMemberModal}>Close</Button>
                    </Modal.Footer>
                </Modal>
                {
                    this.state.errorMessages.length > 0 &&
                    this.state.errorMessages.map(x =>
                        <div><Label bsStyle="danger">{x}</Label></div>
                    )
                }
                <div>
                    <div>
                        <div style={{ float: 'left' }}>
                            <Button bsStyle="info" onClick={this.handleToggleVisibilityFamilyMemberModal}>Add Family Member</Button>
                        </div>
                    </div>
                    <div>
                        <div>

                            <BootstrapTable data={this.state.familyMembers} ref='familyMembersTable'
                                deleteRow selectRow={selectRowProp} options={options}>
                                <TableHeaderColumn hidden isKey dataField='id'>Id</TableHeaderColumn>
                                <TableHeaderColumn width='10%' dataField='relation'>Relation</TableHeaderColumn>

                                <TableHeaderColumn width='20%' dataField='firstName'>First Name</TableHeaderColumn>
                                <TableHeaderColumn width='10%' dataField='middleName'>Middle Name</TableHeaderColumn>
                                <TableHeaderColumn width='25%' dataField='lastName'>Last Name</TableHeaderColumn>

                                <TableHeaderColumn width='10%' dataField='dateOfBirth' dataFormat={ColumnFormatter.asDate}>Date of Birth</TableHeaderColumn>
                                <TableHeaderColumn width='15%' dataField='nationality'>Nationality</TableHeaderColumn>
                                <TableHeaderColumn width='10%' dataField='isPetitioner'>Is Petitioner</TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>

                    <Modal show={this.state.showAddressHistoryModal}
                        onHide={this.closeAddressHistoryModal}>
                        <Modal.Header>
                            <Modal.Title>Add Address</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <form onSubmit={this.handleAddressHistorySubmit}>
                                <AddressComponent
                                    streetNumberName={this.state.streetNumberName}
                                    unitType={this.state.unitType}
                                    unitNumber={this.state.unitNumber}
                                    city={this.state.city}
                                    state={this.state.state}
                                    zipCode={this.state.zipCode}
                                    country={this.state.country}
                                    postalCode={this.state.postalCode}
                                    province={this.state.province}
                                    handleInputChange={this.handleInputChange}
                                />
                                <InputGroup>
                                    <InputGroup.Addon>From Date</InputGroup.Addon>
                                    <FormControl type="date" name="fromDate"
                                        value={this.state.fromDate}
                                        onChange={this.handleInputChange}
                                    />
                                    <InputGroup.Addon>To Date</InputGroup.Addon>
                                    <FormControl type="date" name="toDate"
                                        value={this.state.toDate}
                                        onChange={this.handleInputChange}
                                    />
                                </InputGroup>
                                <div style={{ paddingTop: '1%' }} >
                                    <Button type="submit" bsStyle="primary"> Submit </Button>
                                </div>
                            </form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={this.closeAddressHistoryModal}>Close</Button>
                        </Modal.Footer>
                    </Modal>

                    <div>
                        <h2>Address History</h2>
                        <div style={{ float: 'left' }}>
                            <Button bsStyle="info" onClick={this.handleToggleVisibilityAddressHistoryModal}>Add Address</Button>
                        </div>
                        <BootstrapTable data={this.state.addressHistory} ref='addressHistoryTable'
                            selectRow={selectRowProp} deleteRow options={addressHistoryOptions}>

                            <TableHeaderColumn hidden isKey dataField='id'>Id</TableHeaderColumn>
                            <TableHeaderColumn width='30%' dataField='streetNumberName'>Street Number and Name</TableHeaderColumn>
                            <TableHeaderColumn width='20%' dataField='city'>City</TableHeaderColumn>
                            <TableHeaderColumn width='5%' dataField='state'>State</TableHeaderColumn>
                            <TableHeaderColumn width='5%' dataField='zipCode'>Zip Code</TableHeaderColumn>
                            <TableHeaderColumn width='15%' dataFormat={ColumnFormatter.asDate} dataField='fromDate'>From</TableHeaderColumn>
                            <TableHeaderColumn width='15%' dataFormat={ColumnFormatter.asDate} dataField='toDate'>To</TableHeaderColumn>

                        </BootstrapTable>
                    </div>
                </div>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/Applicant/ApplicantDetails.js